// src/component/page/album/Album.jsx
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useMemo, useState } from 'react';
import { Crafting } from './Crafting';
import { Craftingnft } from './Craftingnft';
import { ViewInventario } from './ViewInventario';
import fondo from '../../../Web Mundo/fondoCrafting.png';
import { Marketlace } from '../../market/Market';
import { SpecialMarket } from '../../market/SpecialMarket';
import { LeaderboardMini } from "./LeaderboardMini";
import { useSearchParams } from 'react-router-dom';
import { HiveMining } from "./HiveMining";

export const Album = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = useMemo(
    () => Number(searchParams.get('page') || '5'),
    [searchParams]
  );

  const [paginas, setPaginas] = useState(initialPage);
  const [evento, setEvento] = useState('');
  const [nft, setNft] = useState(false);
  const [rareza, setRareza] = useState('todas');

  // Keep URL synced when "paginas" changes
  useEffect(() => {
    const current = String(paginas);
    if (searchParams.get('page') !== current) {
      setSearchParams({ page: current });
    }
  }, [paginas, searchParams, setSearchParams]);

  const handleEvento = (e) => setEvento(e);
  const handleChange = (e) => setRareza(e.target.value);

  const go = (p) => setPaginas(p);

  return (
    <Box
      sx={{
        backgroundImage: `url(${fondo})`,
        display: 'flex',
        width: '100%',
        height: { xs: '100%', md: '95vh' },
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
      }}
    >
      {/* ===== Sidebar ===== */}
      <Box sx={{ width: { sm: '40%', lg: '20%' }, marginRight: 1 }}>
        <Box sx={{ width: '100%', display: 'flex', height: '100%', overflow: 'hidden' }}>
          <Box sx={{ width: { sm: '100%' }, height: '100%' }}>
            <Box
              sx={{
                width: '100%',
                height: '100%',
                borderRadius: '10px',
                padding: '10px',
                display: 'flex',
                alignItems: 'stretch',
                backgroundColor: 'rgba(255,200,200,0.2)',
                flexDirection: 'column',
                gap: 0.5, // tighter spacing between menu items
              }}
            >
              {/* order: Ranking, Marketplace, Special Market, Market HIVENFTs, Hive Mining, Burn, Albums, Crafting */}
              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(7)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 7 && activeMenuButtonSx),
                  }}
                >
                  🏆 Global Ranking
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(4)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 4 && activeMenuButtonSx),
                  }}
                >
                  🛒 Marketplace
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(5)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 5 && activeMenuButtonSx),
                  }}
                >
                  💎 Special Market
                </Button>
              </Box>

              {/* external market just under Special Market */}
              <Box sx={menuBoxStyle}>
                <Button
                  component="a"
                  href="https://hivenfts.com/big-dog-bone/buy/"
                  target="_blank"
                  rel="noreferrer"
                  sx={menuButtonSx}
                >
                  🪙 Market HIVENFTs
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(8)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 8 && activeMenuButtonSx),
                  }}
                >
                  ⛏️ Hive Mining
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(6)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 6 && activeMenuButtonSx),
                  }}
                >
                  🔥 Burn NFTs
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(1)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 1 && activeMenuButtonSx),
                  }}
                >
                  📘 General Album
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(2)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 2 && activeMenuButtonSx),
                  }}
                >
                  📗 Special Album
                </Button>
              </Box>

              <Box sx={menuBoxStyle}>
                <Button
                  onClick={() => go(3)}
                  sx={{
                    ...menuButtonSx,
                    ...(paginas === 3 && activeMenuButtonSx),
                  }}
                >
                  🧪 Crafting (Cards)
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ===== Right panel ===== */}
      <Box
        sx={{
          width: '90%',
          height: '100%',
          minHeight: '80vh',
          overflow: 'visible',
        }}
      >
        {paginas <= 2 && <ViewInventario paginas={paginas} />}
        {paginas === 3 && <Crafting />}
        {paginas === 6 && <Craftingnft />}      {/* Burn */}
        {paginas === 4 && <Marketlace />}
        {paginas === 5 && <SpecialMarket />}

        {paginas === 7 && (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <Box
              sx={{
                mb: 2,
                textAlign: 'center',
                color: 'gold',
                fontWeight: 'bold',
                fontSize: { xs: '1.5rem', md: '2rem' },
                textShadow: '0 0 10px black',
              }}
            >
              🏆 Global Ranking
            </Box>

            <LeaderboardMini
              limit={20}
              defaultSort="burned"
              sx={{
                width: '90%',
                height: '90%',
                bgcolor: 'rgba(0,0,0,0.35)',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 2,
                p: 2,
                overflowY: 'auto',
              }}
            />
          </Box>
        )}

        {paginas === 8 && (
          <HiveMining
            onGoToMarket={() => go(5)} // send to Special Market when clicking Buy
          />
        )}
      </Box>
    </Box>
  );
};

const menuBoxStyle = {
  borderBottom: '1px solid gray',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '40px', // slimmer items
  padding: '4px 0',
};

const menuButtonSx = {
  width: '100%',
  justifyContent: 'flex-start',
  textTransform: 'none',
  color: '#ffffff',
  fontWeight: 600,
  fontSize: '0.9rem',
  paddingX: 1,
};

const activeMenuButtonSx = {
  bgcolor: 'rgba(0,0,0,0.45)',
  borderRadius: '6px',
  '&:hover': {
    bgcolor: 'rgba(0,0,0,0.6)',
  },
};
